import { Component, OnInit, Output,EventEmitter  } from '@angular/core';
import { Observable } from 'rxjs';
import { getJobFormSelectors } from './store/job-form.selectors';
import { Store } from '@ngrx/store';
import { IJobFormState } from './store/job-form.state';
import { setJobFormAction } from './store/job-form.actions';
import { IProfession } from 'src/app/modules/interfaces/profession.interface';
import { ProfessionService } from 'src/app/services/professions.service';
import { getCookie } from 'src/app/utils/get-cookie';
@Component({
  selector: 'app-job-form',
  templateUrl: './job-form.component.html',
  styleUrls: ['./job-form.component.scss'],
})
export class JobFormComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();

  formsId: number;
  profession: IProfession = {
    id: 0,
    forms_id: 0,
    work_modalities_id: 1,
    job_title: '',
  };

  workModalities = [
    { id: 1, name: 'CLT/Regime Estatutário' },
    { id: 2, name: 'Pessoa Jurídica / Empresário' },
    { id: 3, name: 'Autônomo' },
    { id: 4, name: 'Aposentado(a)' },
  ];

  isLoading = true;

  isSaving = false;
  saveButtonText = 'Salvar'; 
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IJobFormState>;
  dataState: IJobFormState;

  constructor(
    private store: Store,
    private professionService: ProfessionService
  ) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadProfession();
    
  }

  loadProfession(): void {
    this.isLoading = true
    this.professionService.getProfession(this.formsId).subscribe((response) => {
      if (response) {
        this.profession = {
          id: response.id,
          forms_id: response.forms_id,
          work_modalities_id: response.work_modalities_id,
          job_title: response.job_title || '',
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const data = {
      work_modalities_id: this.profession.work_modalities_id,
      job_title: this.profession.job_title,
    };

    this.professionService.updateProfession(this.formsId, this.profession.id, data)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger'; 
          console.error('Erro ao atualizar a profissão', err);
        }
      });
  }

  saveState(): void {
    const selectedWorkModality = this.workModalities.find(
      (modality) => modality.id === this.profession.work_modalities_id
    );

    this.dataState = {
      ...this.dataState,
      check: true,
      job: this.profession.job_title || '',
      typeJob: selectedWorkModality ? selectedWorkModality.name : '',
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary text-white';
    }
  }

  startTrial(): void {
    this.setState(this.dataState);
  }

  setState(data: IJobFormState) {
    this.store.dispatch(setJobFormAction(data));
    this.isLoading = false
  }

  getState() {
    this.dataState$ = this.store.select(getJobFormSelectors);

    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (this.dataState.job != '' && this.dataState.typeJob != '') {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

  setTypeJob(type: string): void {
    this.dataState.typeJob = type;
    this.setValuesForm();
  }
}
